import { Store } from 'redux';
import { RouterState, RedirectFunction } from 'react-router';

import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import HttpStatus from 'ha/constants/HttpStatus';

const onEnterAuthenticated = (store: Store) => (
  { location }: RouterState,
  replace: RedirectFunction,
) => {
  if (getIsAuthenticated(store.getState())) {
    replace({
      ...location,
      pathname: '/my',
      state: {
        redirectCode: HttpStatus.FOUND_REDIRECTION,
      },
    });
  }
};

export default onEnterAuthenticated;
